// String.replaceAll isn't available on all platforms, so replicate its functionality here.
export const replaceAllInString = (string: string, find: string, replace: string) => string.split(find).join(replace);

export const getThumbnailUrl = url => (url ? `${url}/416/234` : '');

type Template = Record<string, unknown>;

export const replaceTemplateValues = (value: string = '', templateValues: Template) =>
  Object.keys(templateValues).reduce(
    (previousValue: string, current: keyof Template) =>
      previousValue.replace(`{${current}}`, `${templateValues[current]}`),
    value,
  );

// TODO: remove it, add params
export const toQueryString = object =>
  `?${Object.entries(object)
    .map(element => element.join('='))
    .join('&')}`;

// These functions display help manage displaying and detecting missing values.
export const missingValue = '-';

export const displayString = (value: unknown, error?: unknown) => (isDisplayable(value, error) ? value : missingValue);

export const isDisplayable = (value: unknown, error?: unknown) => {
  if (error || !value) {
    return false;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return true;
  }

  return false;
};

// Accessibility
export const accessibleURL = (url: string) =>
  url.replace(/\./g, ' dot ').replace(/\//g, ' slash ').replace(/twc/g, ' T W C ');

export const accessibleCode = code => code?.replace('-', '')?.split('')?.join(' ');

export const accessibleDollarAmount = (amount?: string) => {
  // This works with capture groups. $1 and $2 refer to the first and second capture groups
  // Matches $d+.dd where d+ is any number and dd is a two digit number
  const fixNumbers = amount?.replace(/\$(\d+)\.(\d\d)/g, '$1 dollars and $2 cents');

  // Fixes instances where app uses $/month or $/year
  return fixNumbers?.replace(/\//g, ' per ');
};

export const accessibleTime = time => {
  const fixColon = time?.replace(/(\d):(\d\d)(a|p)/, '$1 $2 $3m');

  return fixColon?.replace('00', '');
};
